<mat-form-field appearance="fill">
  <input matInput [(ngModel)]="searchTerm" (keyup)="getTemplates()" [placeholder]="'Global.Filter' | translate" />
  <button mat-icon-button matPrefix (click)="getTemplates()" [attr.aria-label]="'Global.Filter' | translate">
    <mat-icon>filter_list</mat-icon>
  </button>
</mat-form-field>

@if (selectedTemplates.length) {
  <div>
    <div class="action-title">{{ 'Templates.CurrentTemplates' | translate }}</div>
    <mat-list class="container-grey">
      @for (template of selectedTemplates | filter: searchTerm; track template) {
        <mat-list-item>
          <div class="template-item">
            <span>{{ template.name }}</span>
            <div class="flex items-center gap-1">
              <a mat-icon-button color="primary" [routerLink]="['/myspace/my-models', template._id]" target="_blank" [matTooltip]="'Global.Edit' | translate">
                <mat-icon>edit</mat-icon>
              </a>
              <button mat-icon-button color="warn" [disabled]="loading" (click)="removeTemplate(template._id)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </mat-list-item>
      }
    </mat-list>
  </div>
}
@if (templates.length) {
  <div>
    <div class="action-title">{{ 'Templates.OtherTemplates' | translate }}</div>
    <mat-list class="container-grey">
      @for (template of templates; track template) {
        <mat-list-item>
          <div class="template-item">
            <span>{{ template.name }}</span>
            <div class="flex items-center gap-1">
              <a mat-icon-button color="primary" [routerLink]="['/myspace/my-models', template._id]" target="_blank" [matTooltip]="'Global.Edit' | translate">
                <mat-icon>edit</mat-icon>
              </a>
              <button mat-icon-button color="primary" [disabled]="loading || isSelected(template._id)" (click)="addTemplate(template._id)">
                <mat-icon>add</mat-icon>
              </button>
            </div>
          </div>
        </mat-list-item>
      }
    </mat-list>
  </div>
}
